import { createContext, useContext, useEffect, useState } from "react";

import { NavigateOptions, To } from "react-router-dom";

export type NavigationGuardConfig = {
    enabled: boolean;
    message: string;
    messageButtonSave: string;
    messageButtonClose: string;
    onSave?: (redirectTo?: string, redirectState?: unknown) => Promise<boolean> | boolean;
};

type NavigationGuardContextValue = {
    setNavigationGuard: (config: NavigationGuardConfig) => void;
    navigateWithGuard: (to: To, options?: NavigateOptions) => void;
};

export const NavigationGuardContext =
    createContext<NavigationGuardContextValue>({
        setNavigationGuard: () => undefined,
        navigateWithGuard: () => undefined
    });

export function useNavigationGuard() {
    return useContext(NavigationGuardContext);
}

type Props = {
    children: React.ReactNode;
};

export function NavigationGuardProvider({ children }: Props) {


    const [navigationGuard, setNavigationGuard] =
        useState<NavigationGuardConfig>({
            enabled: false,
            message: "",
            messageButtonSave: "",
            messageButtonClose: ""
        });

    const navigateWithGuard = async (
        to: To,
        options?: NavigateOptions
    ) => {
        if (navigationGuard.enabled) {

            const confirmLeave = window.confirm(
                navigationGuard.message
            );

            if (!confirmLeave) {
                return;
            }
            if (navigationGuard.onSave) {

                await navigationGuard.onSave(
                    typeof to === "string" ? to : to.pathname,
                    options?.state
                );
            }
        }
    };

    useEffect(() => {

        const handleBeforeUnload = (
            event: BeforeUnloadEvent
        ) => {

            if (!navigationGuard.enabled) {
                return;
            }

            event.preventDefault();
            event.returnValue = "";
        };

        window.addEventListener(
            "beforeunload",
            handleBeforeUnload
        );

        return () => {
            window.removeEventListener(
                "beforeunload",
                handleBeforeUnload
            );
        };

    }, [navigationGuard.enabled]);

    return (
        <NavigationGuardContext.Provider
            value={{
                setNavigationGuard,
                navigateWithGuard
            }}
        >
            {children}
        </NavigationGuardContext.Provider>
    );
}